import { useGlobalStore } from '@atlas/shared-state';

export function useAuth() {
  const user = useGlobalStore((state) => state.user);
  const isAuthenticated = useGlobalStore((state) => state.isAuthenticated);
  const isLoading = useGlobalStore((state) => state.isLoading);
  const permissions = useGlobalStore((state) => state.permissions);

  // Backwards-compat: check both 'Administrator' (legacy) and 'SystemAdmin' (current).
  // Users provisioned before the role rename still carry 'Administrator' in their JWT.
  // TODO: Remove 'Administrator' check after a one-time DB migration updates all role assignments to 'SystemAdmin'.
  const isSystemAdmin =
    user?.roles?.includes('Administrator') ||
    user?.roles?.includes('SystemAdmin') ||
    permissions.some(
      (p) => p.module === 'system' && p.resource === '*' && p.action === '*'
    );

  return { user, isAuthenticated, isLoading, permissions, isSystemAdmin };
}
